import { render, staticRenderFns } from "./commentItem.vue?vue&type=template&id=ab7d8aba&scoped=true&lang=html&"
import script from "./commentItem.vue?vue&type=script&lang=js&"
export * from "./commentItem.vue?vue&type=script&lang=js&"
import style0 from "./commentItem.vue?vue&type=style&index=0&id=ab7d8aba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7d8aba",
  null
  
)

export default component.exports